// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assets-drawer[data-v-0eb6be80] .avue-crud__menu{display:none}.assets-drawer[data-v-0eb6be80] .el-drawer__header{margin-bottom:0}.assets-drawer[data-v-0eb6be80] .el-drawer__body{padding-top:0}.assets-drawer[data-v-0eb6be80] .avue-crud__search .avue-form{padding:0}.assets-drawer[data-v-0eb6be80] .el-select{display:inline-block;position:relative;width:100%}", ""]);
// Exports
module.exports = exports;
